import get from 'lodash/get';
import { string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect, useSelector } from 'react-redux';
import wretch from 'wretch';

import { WithLazy } from '@quintype/components';
import { sectionNameDataLayer } from '../../../helpers/datalayer-utils';
import ViewAll from '../../atoms/view-all';
import VideoTitle from '../../molecules/titles/videos';
import AdWithPlaceholder from '../ad-with-placeholder';
import VideoCardImageHeadlineAuthor from '../video-card-image-headline-author';

import MoreLikeThisWidget from '../../story/more-like-this-widget';
import './right-side-bar.m.css';

const RightSidebar = ({ pageType, stories, isSubscriber }) => {
  const firstStory = stories && typeof stories === 'object' && Object.values(stories)[0];

  const [videos, setVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadVideos = async () => {
      try {
        const response = await wretch('/api/v1/collections/in-the-news-videos').get().json();
        setVideos(get(response, 'items', []).slice(0, 4));
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const timer = setTimeout(() => loadVideos(), 250);
    return () => clearTimeout(timer);
  }, []);

  const renderAd = (adType, adUnit, className) => (
    <div className={`responsive-ad ${className} content-center`}>
      <AdWithPlaceholder
        adtype={adType}
        height="250px"
        width="300px"
        adUnit={adUnit}
        sizes={[[300, 250]]}
      />
    </div>
  );
  const userData = useSelector((state) => get(state, ['userData']));

  return (
    <div styleName="right-side-bar">
      <div styleName={pageType !== 'market-page' && !isMobile && isSubscriber ? "videos-wrapper videos-section" : "videos-wrapper"}>
        {pageType !== 'market-page' && !isMobile && renderAd('ResRepAboveMostRead', 'Top_300x250', 'desktop-only')}
        <h5 styleName={pageType !== 'market-page' && !isMobile && !isSubscriber ? "videos-title title" : "videos-title"} className="title-with-view-all" style={{ display: "flex" }} onClick={() => sectionNameDataLayer("videos", userData, pageType)}>
          <VideoTitle />
          <ViewAll isTitle />
        </h5>
        <div
          styleName="videos"
          className={videos.length === 0 ? "loading-videos" : ""}
        >
          {videos.map((item, index) => (
            <VideoCardImageHeadlineAuthor key={index} story={item.story} />
          ))}
        </div>

      </div>
      {!isMobile && renderAd('ResRepAboveMoreLikeThis', 'Mid_300x250_1', 'desktop-only')}
      <div styleName="more-like-this">
        <WithLazy>
          {() => (
            <>
              {firstStory &&
                <MoreLikeThisWidget story={firstStory} />
              }
            </>
          )}
        </WithLazy>
      </div>
      {!isMobile && firstStory && renderAd('AboveMoreLikeThis', 'Mid_300x250_2', 'desktop-only')}
    </div>
  );
};

RightSidebar.propTypes = {
  pageType: string.isRequired,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ['qt', 'pageType'], 'market-page'),
  isSubscriber: get(state, ['userData', 'isSubscriber'], false),
});

export default connect(mapStateToProps)(RightSidebar);
